import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';


const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'studentNo', label: '学号', width: 160},
    {key:'name', label: '姓名'},
    {key:'birthday', label: '生日', render: (value)=> (value ? moment(new Date(value)).format('YYYY/MM/DD') : '--'), width: 180},
    {key:'sex', label: '性别', render: (value) => value === 1 ? '男' : '女'},
    {key:'orgName', label: '所属部门'},
    {key:'classGrade', label: '年级'},
    {key:'classesName', label: '班级', width: 200}
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('student/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
}